import { default as PageLayout } from './PageLayout';
import { default as NavSidebar } from './NavSidebar';

const EXPORT = { PageLayout, NavSidebar };

export default EXPORT;
